import React from "react";
import { LoadingSpinner, Alert } from "components/common";

const TournamentPage = () => {
  const TOURNAMENT_URL = process.env.REACT_APP_TOURNAMENT_URL;

  return (
    <div>
      {TOURNAMENT_URL ? (
        <iframe
          title="Tournament"
          src={TOURNAMENT_URL}
          width="100%"
          style={{ minHeight: '600px', border: 'none' }}
          sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
          allow="fullscreen; geolocation"
        />
      ) : (
        <div className="tw-text-center tw-p-12">
          <LoadingSpinner message="Loading..." />
        </div>
      )}

      <Alert type="info" className="tw-mb-4">
        In case the Tournament cannot authorize, please click{" "}
        <a href={TOURNAMENT_URL} target="_blank" rel="noopener noreferrer">
          here
        </a>{" "}
        to access it in a new page.
      </Alert>
    </div>
  );
};

export default TournamentPage;
